import React from "react";
import { Route, Redirect, Switch, useHistory } from "react-router-dom";
import "./Routes.scss";
import loadable from "@loadable/component";
import {trackPage} from "analytics";
import Header from "components/Header/Header";


import { useQuery } from "react-query";
import {CLIENTE} from "api/TYPES";
import {crudFunctions, getCustomer, getUser} from "api";
import { createState, useState } from '@hookstate/core';
import {userStore, useUserStore} from 'api/store';
import Perfil from "pages/Login/Perfil";
import styled from "styled-components";
import Whatsapp from "assets/img/whatsApp.png";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import SiniestroModal from "pages/Seguros/SiniestroModal";
const fallback = ()=> <CircularProgress />

const Home = loadable(() => import("../pages/Home/Home"),fallback);
const NavBar = loadable(() => import("../components/NavBar/VNavBar"));
const TablaPagos = loadable(() => import("../pages/Pagos/TablaPagos"),fallback);
const SolicitudCredito = loadable(() => import("../pages/Credito/SolicitudCredito"),fallback);
const CalculadoraComisiones = loadable(() => import("../pages/Broker/CalculadoraComisiones"),fallback);
const MisClientes = loadable(() => import("../pages/Broker/MisClientes"),fallback);
const DatosIniciales = loadable(() => import("../pages/Login/DatosIniciales"),fallback);
const EnRevision = loadable(() => import("../pages/Login/EnRevision"),fallback);
const Configuracion = loadable(() => import("../pages/Configuracion/Configuracion"),fallback);
const CotizarSeguroBase = loadable(() => import("pages/Seguros/NuevoSeguro/NuevoSeguro"),fallback);
const CotizarSeguro = (props) => <CotizarSeguroBase key={props.location?.key} {...props} />;
const TablaSeguros = loadable(() => import("pages/Seguros/TablaSeguros"),fallback);
const TablaSiniestros = loadable(() => import("pages/Seguros/TablaSiniestros"),fallback);
const SiniestroMobile = loadable(() => import("pages/Seguros/SiniestroMobile/SiniestroPage"),fallback);
const Seguro = loadable(() => import("pages/Seguros/Seguro"),fallback);
const FinalizarCuenta = loadable(() => import("pages/Login/FinalizarCuenta"),fallback);
const Plan = loadable(() => import("pages/Configuracion/Plan"),fallback);
const ImportarSeguros = loadable(() => import("pages/Seguros/NuevoSeguro/SegurosMasivos/ImportarSeguros"),fallback);
const TablaPolizasAuto = loadable(() => import("pages/SegurosAuto/TablaPolizasAuto"),fallback);
const PolizaAuto = loadable(() => import("pages/SegurosAuto/PolizaAuto"),fallback);
const PlanesAuto = loadable(() => import("pages/SegurosAuto/PlanesAuto"),fallback);
const EstadisticasAuto = loadable(() => import("pages/SegurosAuto/EstadisticasAuto"),fallback);
// Los brokers solo entran al asistente de auto (`/nuevo-seguro/auto?id_cliente=`); el resto de productos sigue cerrado para ellos.
const CotizarSeguroBroker = (props) => (props.match?.params?.tipo === "auto" ? <CotizarSeguro {...props} /> : <BrokerDashboardRedirect />);
const Activar = loadable(() => import("../pages/Login/Activar"),fallback);
const Login = loadable(() => import("../pages/Login/Login"),fallback);
const Registro = loadable(() => import("../pages/Login/Registro"),fallback);
const Forgot = loadable(() => import("../pages/Login/Olvide"),fallback);
const Reset = loadable(() => import("../pages/Login/Reset"),fallback);
const PrivateRoute = loadable(() => import("./PrivateRoute/PrivateRoute"));
const PublicRoute = loadable(() => import("./PublicRoute/PublicRoute"));
const BrokerDashboardRedirect = () => <Redirect to="/dashboard" />;
const CustomerInsuranceRedirect = () => <Redirect to="/nuevo-seguro" />;

const Float = styled.a`
	display:flex;
	align-items:center;
	justify-content:center;
	position:fixed;
	width:60px;
	height:60px;
	bottom:40px;
	right:40px;
	background-color:#25d366;
	color:#FFF;
	border-radius:50px;
	text-align:center;
  font-size:30px;
	box-shadow: 2px 2px 3px #999;
  z-index:100;
`;

 
const Routes = () => {
	const {data:user, status:s2} = useQuery(CLIENTE.name, getCustomer);
	const isBroker = user?.usuario?.role === "broker";

	// const {user} = useUserStore();
	const state = useState(userStore);
	const status = state.status.get();
	const loggedIn = state.loggedIn.get();
	// const user = state.user.get();
	
	React.useEffect(()=>{
		let path = window.location.pathname;
		const myregexp = /[0-9a-fA-F]{24}/g;
		path = path.replace(myregexp, "id");
		trackPage(path);
	},[window.location.pathname]);

	let RNavBar = window.location.pathname.includes("/siniestro-mobile") || window.location.pathname === "/dedicado"||window.location.pathname === "/login" || window.location.pathname === "/registro" || window.location.pathname.startsWith("/reset") || window.location.pathname.startsWith("/reset") || window.location.pathname === "/forgot" ? null : <><NavBar cliente={user} /></>;

	
	// if (status==="loading")return <>Loading</>;
	// if (status==="error")return <>Error</>;
	// if (status==="error"){
	// 	return <>
	// 		<PublicRoute user={user} exact path="/login" component={Login} />
	// 		<PublicRoute user={user} exact path="/registro" component={Registro} />
	// 		<PublicRoute user={user} exact path="/forgot" component={Forgot} />
	// 		<PublicRoute user={user} exact path="/reset/:token/:idNutriologo" component={Reset} />
	// 	</>;
	// }
	if(user?.cliente?.status==="pendiente")return <>
		<Redirect to={{ pathname: "/pendiente-documentos" }} />
		{RNavBar}
		<div className="container">
			<DatosIniciales />
		</div>
	</>;
	else if(user?.cliente?.status==="en_revision")return <>
		<Redirect to={{ pathname: "/en-revision" }} />
		{RNavBar}
		<div className="container">
			<EnRevision />
		</div>
	</>;
	return (
		<>
			{RNavBar}
			<CreditActivationPrompt user={user} />
			{/* <Float href="https://api.whatsapp.com/send?phone=5215563160030" target="_blank">
				<img src={Whatsapp} style={{width:40,height:40,color:'white'}} />
			</Float> */}
			<div>
				<Switch>
					<Route status={status} loggedIn={loggedIn} exact path="/siniestro-mobile/:id" component={SiniestroMobile} />
					<PublicRoute status={status} loggedIn={loggedIn} exact path="/login" component={Login} />
					<PublicRoute status={status} loggedIn={loggedIn} exact path="/registro" component={Registro} />
					<PublicRoute status={status} loggedIn={loggedIn} exact path="/forgot" component={Forgot} />
					<PublicRoute status={status} loggedIn={loggedIn} exact path="/reset/:token/:id" component={Reset} />
					<PublicRoute status={status} loggedIn={loggedIn} exact path="/activar/:token/:idUsuario" component={Activar} />
					<PublicRoute status={status} loggedIn={loggedIn} path="/asignar-password" component={FinalizarCuenta} />


					<Route path={["/dashboard", "/nuevo-seguro", "/importar-seguros", "/siniestro/:id", "/seguro/:id", "/seguros", "/siniestros", "/seguros-auto", "/seguro-auto/:id", "/planes-auto", "/estadisticas-auto", "/pagos", "/credito/solicitud", "/mis-clientes", "/calculadora-comisiones", "/configuracion", "/perfil", "/plan"]}>
						<div className="container-app">
							<Switch>
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/dashboard" component={Home} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/importar-seguros" component={isBroker ? BrokerDashboardRedirect : ImportarSeguros} />
								<PrivateRoute status={status} loggedIn={loggedIn} path="/nuevo-seguro/:tipo?" component={isBroker ? CotizarSeguroBroker : CotizarSeguro} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/siniestro/:id" component={isBroker ? BrokerDashboardRedirect : SiniestroModal} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/seguro/:id" component={Seguro} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/seguros" component={TablaSeguros} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/siniestros" component={isBroker ? BrokerDashboardRedirect : TablaSiniestros} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/seguros-auto" component={TablaPolizasAuto} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/seguro-auto/:id" component={PolizaAuto} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/planes-auto" component={PlanesAuto} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/estadisticas-auto" component={isBroker ? EstadisticasAuto : CustomerInsuranceRedirect} />
								<PrivateRoute status={status} loggedIn={loggedIn} path="/pagos" component={TablaPagos} />
								<PrivateRoute status={status} loggedIn={loggedIn} path="/credito/solicitud" component={SolicitudCredito} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/mis-clientes" component={isBroker ? MisClientes : CustomerInsuranceRedirect} />
								<PrivateRoute status={status} loggedIn={loggedIn} exact path="/calculadora-comisiones" component={isBroker ? CalculadoraComisiones : CustomerInsuranceRedirect} />
								<PrivateRoute status={status} loggedIn={loggedIn} path="/configuracion/:seccion?/:empresa?" component={Configuracion} />
								<PrivateRoute status={status} loggedIn={loggedIn} path="/perfil" component={Perfil} />
								<PrivateRoute status={status} loggedIn={loggedIn} path="/plan" component={Plan} />
							</Switch>
						</div>
					</Route>

					{s2 === "loading" || s2 === "idle"
						? <Route render={()=><div className="flex min-h-[240px] items-center justify-center"><CircularProgress /></div>} />
						: <Redirect to={isBroker ? "/dashboard" : "/nuevo-seguro"} />}
				</Switch>
			</div>
		</>
	);
	
	
};

export default Routes;

function CreditActivationPrompt({user}) {
	const history = useHistory();
	const cliente = user?.cliente;
	const storageKey = cliente?._id ? `hover-credit-prompt-dismissed:${cliente._id}` : "";
	const [dismissed, setDismissed] = React.useState(() => storageKey ? window.localStorage.getItem(storageKey) === "true" : false);
	React.useEffect(() => {
		setDismissed(storageKey ? window.localStorage.getItem(storageKey) === "true" : false);
	}, [storageKey]);
	const hasPendingCompanyRfc = cliente?.seguro_paqueteria && (cliente.empresas_seguro_paqueteria || []).some(empresa => !empresa?.rfc?.trim());
	const open = Boolean(
		cliente?.status === "activo" &&
		user?.usuario?.role !== "broker" &&
		cliente?.credito_resumen?.estado === "sin_credito" &&
		!dismissed &&
		!hasPendingCompanyRfc &&
		!window.location.pathname.startsWith("/credito/")
	);
	const dismiss = () => {
		if(storageKey) window.localStorage.setItem(storageKey, "true");
		setDismissed(true);
	};
	return <Dialog open={open} fullWidth maxWidth="sm">
		<DialogTitle>¿Quieres activar una línea de crédito HOVER?</DialogTitle>
		<DialogContent>
			Podrás emitir seguros y pagarlos de forma diferida. Elige un nivel de hasta $20,000, $50,000, $399,000 o $5,000,000 MXN; revisaremos tu información antes de activarlo.
		</DialogContent>
		<DialogActions>
			<Button onClick={dismiss}>Ahora no</Button>
			<Button color="primary" variant="contained" onClick={() => { dismiss(); history.push("/credito/solicitud"); }}>Activar crédito</Button>
		</DialogActions>
	</Dialog>;
}
